import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('ProfileLinkWrapper', {
    attrs: {
      "threshold": 0
    },
    on: {
      "event": function ($event) {
        return _vm.$emit('event', $event);
      }
    }
  }, [_c('div', {
    staticClass: "site-links-text",
    class: _vm.classes,
    style: _vm.styles,
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    },
    on: {
      "click": _vm.handleClick
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-257a65f8_0", {
    source: ".site-container--preview .site-links-text hr{border-top-width:2px}.site-links-text{background:var(--c-bg-color);border:var(--p-btn-border-width) solid var(--p-btn-border-color);border-width:min(var(--p-btn-border-width),5px);border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px);box-shadow:var(--p-btn-box-shadow);overflow:hidden;color:var(--c-text-color);font-family:var(--p-font-family);font-size:.925rem;line-height:1.75;padding:1rem}.site-links-text--remove-bg{background:0 0;border:none;border-radius:0;box-shadow:none;padding:.75rem 0}.site-links-text--centered{text-align:center}.site-links-text>:first-child{margin-top:0}.site-links-text>:last-child{margin-bottom:0}.site-links-text blockquote,.site-links-text ol,.site-links-text p,.site-links-text pre,.site-links-text table,.site-links-text ul{font-size:1em;margin:0 0 15px}.site-links-text iframe,.site-links-text img{max-width:100%;vertical-align:revert}.site-links-text h1,.site-links-text h2,.site-links-text h3,.site-links-text h4{margin:19px 0 8px;font-weight:700;line-height:1.42}.site-links-text h1{font-size:2em}.site-links-text h2{font-size:1.66em}.site-links-text h3{font-size:1.25em}.site-links-text h4{font-size:1em}.site-links-text h5{font-size:.88em}.site-links-text h6{font-size:.75em}.site-links-text a{color:inherit;text-decoration:underline;font-weight:600}.site-links-text small{font-size:.7em}.site-links-text blockquote{border-left:.6em solid var(--c-highlight-bg-color);padding:1em;margin-left:10px}.site-links-text blockquote p:last-child{margin-bottom:0}.site-links-text pre{background-color:var(--c-highlight-bg-color);border:none;display:block;padding:.5em;line-height:1.25;overflow-x:scroll;text-align:left}.site-links-text code,.site-links-text pre{color:inherit;font-family:inherit;font-size:87.5%;max-width:unset}.site-links-text code{background-color:transparent}.site-links-text pre code{font-size:inherit;color:var(--c-highlight-color);word-break:normal}.site-links-text ol,.site-links-text ul{padding-left:2em}.site-links-text hr{margin-top:1em;margin-bottom:1em;border:0;border-top-color:currentcolor;border-top-style:none;border-top-width:0;border-top:1px solid var(--p-text-color)}.site-links-text table{border:none;border-collapse:collapse;color:inherit;width:100%}.site-links-text table thead th{vertical-align:bottom;border-bottom:2px solid var(--c-highlight-bg-color);border-top:none}.site-links-text table td,.site-links-text table th{border-top:1px solid var(--c-highlight-bg-color);padding:.5em .75em;vertical-align:top}.site-links-text table th{text-align:inherit}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ProfileText = __vue_component__;
export { ProfileText as default };